export const legacyRequestFileExtension = '.request';
export const requestFileExtension = '.pxrequest';

export const legacyReleaseFileExtension = '.release';
export const releaseFileExtension = '.pxrelease';
